import Big from "big.js";
import {CurrencyDefinition} from "../http/protocol";

export default class CurrencyFormatter {

    static currencyCode:string;
    static decimals:number;

    static format(amount:Big, currencyCode: string, decimals: number):string {

        if (currencyCode == 'USD') {
            return '$'+amount.toFixed(decimals);

        } else if (currencyCode == 'EUR') {
            return '€'+amount.toFixed(decimals);

        } else {
            return currencyCode + " " + amount.toFixed(decimals);
        }

    }

    static formatWithSymbol(currency: CurrencyDefinition | undefined, amount?:Big|number, skipPostfixSymbol?: boolean):string {
        if(typeof(amount) == "undefined") {
            return ""
        }
        let finalAmount;
        if(typeof (amount) == "number") {
            finalAmount = new Big(amount);
        } else  {
            finalAmount = amount;
        }
        if(currency != undefined) {
            let postfixSymbol = currency.postfixSymbol;
            if(skipPostfixSymbol === true) {
                postfixSymbol = undefined;
            }
            return `${currency.prefixSymbol != undefined ? currency.prefixSymbol : ""}${finalAmount.toFixed(currency.fractionalDigits)}${postfixSymbol != undefined ? postfixSymbol : ""}`;
        }

        return "";

    }
    static jackpotFormat(currency: CurrencyDefinition | undefined, amount?:Big|number):string {
        if(typeof(amount) == "undefined") {
            return ""
        }
        let finalAmount;
        if(typeof (amount) == "number") {
            finalAmount = new Big(amount);
        } else  {
            finalAmount = amount;
        }
        if(currency != undefined) {
            let amountStr = finalAmount.toFixed(0);
            const thousands = /\B(?=(\d{3})+(?!\d))/g;
            amountStr = amountStr.replaceAll(thousands," ");
            return `${currency.prefixSymbol != undefined ? currency.prefixSymbol : ""}${amountStr}${currency.postfixSymbol != undefined ? currency.postfixSymbol : ""}`;
        }

        return "";

    }

    static currencySymbol (currencyCode: string | undefined) {

        if (currencyCode == 'USD') {
            return '$';

        } else if (currencyCode == 'EUR') {
            return '€';

        } else if (currencyCode == 'mBTC') {
            return 'm₿';

        } else if (currencyCode == 'uBTC') {
            return 'u₿';

        } else {
            return currencyCode;
        }

    }

}